<template>
  <div class="custom-page-box">
    <a-card title="子账号管理" :headStyle="{fontSize:'18px'}">
      <a-tabs style="background-color: white;" default-active-key="1">
        <a-tab-pane tab="账号列表" key="1">
          <AccountListComponents></AccountListComponents>
        </a-tab-pane>
        <a-tab-pane tab="角色权限" key="2">
          <RolePermissionsComponents></RolePermissionsComponents>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import RolePermissionsComponents from './components/RolePermissionsComponents'
import AccountListComponents from './components/AccountListComponents'

export default {
  name: 'SubAccount',

  components: { RolePermissionsComponents, AccountListComponents },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="less">
@import "../CustomPage";
</style>